import { State } from '../reducers/rootReducer'

const e3dSharingDashboardSelector = (state: State): boolean => state.e3dSharingDashboard.isVisible

export default e3dSharingDashboardSelector
